// extracted by mini-css-extract-plugin
module.exports = {"container":"SummaryPage_container__2qIpx","error":"SummaryPage_error__3gNS7","success":"SummaryPage_success__qIE7v","buttons":"SummaryPage_buttons__2d_hr"};